const ACCESS_TOKEN_KEY = 'accessToken';
const REFRESH_TOKEN_KEY = 'refreshToken';
const USER_ID_KEY = 'userId';
const USER_ROLE_KEY = 'userRole';
const USER_NAME_KEY = 'userName';
const COMPANY_ID_KEY = 'companyId';
const COMPANY_LOGO_KEY = 'companyLogo';
const POST_LWD_NOTICE_KEY = 'postLwdNotice';

// Getters
export const getAccessToken = () => localStorage.getItem(ACCESS_TOKEN_KEY);
export const getRefreshToken = () => localStorage.getItem(REFRESH_TOKEN_KEY);
export const getUserId = () => localStorage.getItem(USER_ID_KEY);
export const getUserRole = () => localStorage.getItem(USER_ROLE_KEY);
export const getUserName = () => localStorage.getItem(USER_NAME_KEY);
export const getCompanyId = () => localStorage.getItem(COMPANY_ID_KEY);
export const getCompanyLogo = () => {
  try {
    const value = localStorage.getItem(COMPANY_LOGO_KEY);
    if (!value || value === 'undefined' || value === 'null') {
      return null;
    }
    return JSON.parse(value);
  } catch (e) {
    console.error('Error parsing company logo:', e);
    return null;
  }
};
export const getPostLwdNotice = () => {
  try {
    const value = localStorage.getItem(POST_LWD_NOTICE_KEY);
    if (!value || value === 'undefined' || value === 'null') {
      return null;
    }
    return JSON.parse(value);
  } catch (e) {
    return null;
  }
};

// Setters
export const setTokens = (accessToken, refreshToken, userId, userRole , userName ,companyId , companyLogo, postLwdNotice) => {
  if (accessToken) localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
  if (refreshToken) localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
  if (userId) localStorage.setItem(USER_ID_KEY, userId);
  if (userRole) localStorage.setItem(USER_ROLE_KEY, userRole);
  if (userName) localStorage.setItem(USER_NAME_KEY, userName);
  if (companyId) localStorage.setItem(COMPANY_ID_KEY, companyId);
  localStorage.setItem(COMPANY_LOGO_KEY, companyLogo ? JSON.stringify(companyLogo) : null);
  if (postLwdNotice) {
    localStorage.setItem(POST_LWD_NOTICE_KEY, JSON.stringify(postLwdNotice));
  } else {
    localStorage.removeItem(POST_LWD_NOTICE_KEY);
  }
};

// Clear Tokens
export const clearTokens = () => {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
  localStorage.removeItem(USER_ID_KEY);
  localStorage.removeItem(USER_ROLE_KEY);
  localStorage.removeItem(USER_NAME_KEY);
  localStorage.removeItem(COMPANY_ID_KEY);
  localStorage.removeItem(COMPANY_LOGO_KEY);
  localStorage.removeItem(POST_LWD_NOTICE_KEY);
};
